module.exports = __webpack_public_path__ + "img/16581269_S.dfc4969b.png";